import axios from 'axios';

import { getValidAccessToken } from './authUtils';

export const getFileNameWithoutExtension = (fileName) => {
  if (typeof fileName !== 'string') return '';

  const trimmed = fileName.trim();
  if (trimmed === '') return '';

  // Hidden file like ".gitignore" with no further dots
  if (trimmed.startsWith('.') && trimmed.indexOf('.', 1) === -1) {
    return trimmed;
  }

  const lastDotIndex = trimmed.lastIndexOf('.');

  // No dot found or dot at start (hidden file with no extension)
  if (lastDotIndex <= 0) {
    return trimmed;
  }

  return trimmed.substring(0, lastDotIndex);
};

export const stopPropagationFunc = (e) => {
  if (e?.domEvent) {
    e.domEvent?.stopPropagation();
  }
};

export const getExternalLink = async (link) => {
  const accessToken = await getValidAccessToken();
  const url = `${link}#access_token=${accessToken}&refresh_token=${localStorage.getItem(
    'refresh_token'
  )}&expires_at=${localStorage.getItem('token_expires_at')}`;
  return url;
};

export const formatIndianLongDate = (dateInput) => {
  if (!dateInput) return '';

  return new Date(dateInput).toLocaleDateString('en-IN', {
    dateStyle: 'long',
    timeZone: 'Asia/Kolkata',
  });
};

export const getSearchRegex = (value) => {
  return new RegExp(value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
};

export const getAxiosErrorMessage = (error) => {
  if (!axios.isAxiosError(error)) {
    return 'An unexpected error occurred.';
  }

  if (error.response) {
    if (error.response.data?.message) return error.response.data.message;

    if (Array.isArray(error.response.data?.errors)) {
      return error.response.data.errors[0].msg || error.response.data.errors[0];
    }

    switch (error.response.status) {
      case 401:
        return 'Unauthorized. Please log in again.';
      case 403:
        return 'You do not have permission to perform this action.';
      case 404:
        return 'The requested resource was not found.';
      case 500:
        return 'Internal Server Error. Try again later.';
      default:
        return `Error: ${error.response.statusText}`;
    }
  }

  if (error.request) {
    return 'No response from server. Please check your internet connection.';
  }

  return error.message || 'An unknown error occurred.';
};
